import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { Position, Tag } from '@sh/types';
import { cloneDeep } from 'lodash';
import { computed, ref } from 'vue';

interface Props {
  placement?: Position;
  tags?: Tag[];
  emptyMessage?: string;
}

interface Emits {
  (e: 'event', value: Tag[]): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcTagsFilter.ts',
  props: {
    placement: { default: Position.RIGHT },
    tags: { default: () => [] },
    emptyMessage: { default: 'There are no tags to filter. Add them in Creative Library for desired images.' }
  },
  emits: ["event"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'event', value: Tag[]): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { placement: Position, tags: Tag[], emptyMessage: string };





const show = ref(false);

const currentTags = ref<Tag[]>([]);

const selected = computed(
  () => currentTags.value.filter((tag) => tag.selected).length || props.tags.filter((tag) => tag.selected).length
);

const search = ref('');

function reset() {
  currentTags.value = cloneDeep(props.tags);
  search.value = '';
}

function onSearchChange() {
  currentTags.value = props.tags.filter(
    (tag) => tag.name.toLowerCase().includes(search.value.toLowerCase()) || tag.selected
  );
}

function onFilter() {
  emits('event', currentTags.value);
  show.value = false;
}

return { __sfc: true,props, emits, show, currentTags, selected, search, reset, onSearchChange, onFilter, CcIcon }
}

})